import classNames from 'classnames';
import { Radio, RadioGroup } from 'rsuite';
import { ButtonPrimary } from '../../../../../components/ButtonPrimary';
import { Footer } from '../Layout/Footer';
import { EngineUpdateRecipientsBlock } from './components/EngineUpdateRecipientsBlock';
import { UserSelectionModal } from './components/UserSelectionModal';
import { useEngineUpdateNotificationsController } from './hooks/useEngineUpdateNotificationsController';
import { EngineUpdateNotificationOption } from './types';
import styles from './SetupIpaEngineUpdateNotifications.module.scss';

const ENGINE_UPDATE_OPTIONS: { value: EngineUpdateNotificationOption; label: string; description: string }[] = [
  { value: 'NAO_ENVIAR', label: 'Não enviar', description: 'Ninguém é avisado quando o motor conclui a rodada.' },
  {
    value: 'USUARIOS_SELECIONADOS',
    label: 'Usuários específicos',
    description: 'Você escolhe quem recebe o aviso por e-mail. Se quiser que administradores recebam, inclua-os na lista.',
  },
];

export const SetupIpaEngineUpdateNotifications = () => {
  const { data, state, loading, handlers } = useEngineUpdateNotificationsController();
  const showRecipients = data.option !== 'NAO_ENVIAR';

  return (
    <div className={styles.root}>
      <header className={classNames(styles.card, styles.header)}>
        <h2 className={styles.title}>Avisos e notificações</h2>
        <p className={styles.description}>
          Configure quais avisos do IPA sua equipe recebe e quem é notificado. Por enquanto, os avisos são enviados por e-mail.
        </p>
      </header>

      <section className={styles.card}>
        <header className={styles.header}>
          <h3 className={styles.title}>Atualização do motor</h3>
          <p className={styles.description}>
            Avisamos por e-mail quando o motor de precificação conclui a rodada diária e os dados do IPA já estão atualizados. Escolha quem recebe:
          </p>
        </header>

        <RadioGroup className={styles.options} value={data.option} onChange={value => handlers.changeOption(value as EngineUpdateNotificationOption)}>
          {ENGINE_UPDATE_OPTIONS.map(option => (
            <div key={option.value} className={styles['option-item']}>
              <Radio value={option.value}>
                <span>{option.label}</span>
              </Radio>
              <p className={styles['option-description']}>{option.description}</p>
            </div>
          ))}
        </RadioGroup>

        {showRecipients && <EngineUpdateRecipientsBlock recipients={data.recipients} onRemove={handlers.removeRecipient} onAddClick={handlers.openUserModal} />}
      </section>

      <Footer>
        <ButtonPrimary size="medium" theme="ghost" type="button" onClick={handlers.cancel}>
          cancelar
        </ButtonPrimary>
        <ButtonPrimary size="medium" type="button" isLoading={loading.saving} onClick={handlers.save}>
          salvar
        </ButtonPrimary>
      </Footer>

      <UserSelectionModal
        show={state.isUserModalOpen}
        selectedUserIds={data.recipients.map(recipient => recipient.cdUsuario)}
        onCancel={handlers.closeUserModal}
        onConfirm={handlers.applyUserSelection}
      />
    </div>
  );
};
